var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26.0012721px",
    height: "25.5532149px",
    viewBox: "0 0 26.0012721 25.5532149",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:megaphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-Light-New-Icons",
    transform: "translate(-16, -359.9997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:megaphone",
    transform: "translate(13, 357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7866667,21.12 C12.8599557,21.0396347 11.930189,20.9995969 11,21 L10,21 C6.6862915,21 4,18.3137085 4,15 C4,11.6862915 6.6862915,9 10,9 L11,9 C11.9386667,9 12.8693333,8.96 13.7866667,8.88 M13.7866667,21.12 C14.124,22.4026667 14.5653333,23.6426667 15.1,24.8306667 C15.4293333,25.564 15.18,26.444 14.4826667,26.8453333 L13.6066667,27.352 C12.872,27.776 11.9266667,27.508 11.5706667,26.7373333 C10.7257211,24.9093991 10.0819413,22.9950482 9.65066667,21.028 M13.7866667,21.12 C13.2626426,19.1222616 12.998243,17.0653225 13,15 C13,12.8853333 13.2733333,10.8346667 13.7866667,8.88 M13.7866667,21.12 C17.8953579,21.4721412 21.8963232,22.6201262 25.5666667,24.5 M13.7866667,8.88 C17.8953641,8.52789232 21.8963357,7.37990555 25.5666667,5.5 M25.5666667,5.5 C25.4103108,4.99585374 25.2413691,4.49569733 25.06,4 M25.5666667,5.5 C26.2920029,7.83792043 26.7456587,10.2516018 26.9186667,12.6933333 M25.5666667,24.5 C25.4093333,25.0066667 25.24,25.5053333 25.06,26 M25.5666667,24.5 C26.2920029,22.1620796 26.7456587,19.7483982 26.9186667,17.3066667 M26.9186667,12.6933333 C27.6045127,13.2630398 28.0012721,14.1084002 28.0012721,15 C28.0012721,15.8915998 27.6045127,16.7369602 26.9186667,17.3066667 M26.9186667,12.6933333 C27.0280732,14.2291652 27.0280732,15.7708348 26.9186667,17.3066667",
    id: "Shape",
    stroke: "#192340",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingBlack);
export default __webpack_public_path__ + "static/media/marketing-black.73393a311be163ecab936bf1d076091f.svg";
export { ForwardRef as ReactComponent };